module.exports = __webpack_public_path__ + "img/manda_030.5c6d143c.png";